import React from 'react'

import './App.css'
import FitnessTracker from './pages/FitnessTracker'

function App() {

  return (
    <>
      <FitnessTracker />
    </>
  )
}

export default App
